import mediaQueries from 'syf-component-library/const/mediaQueries';
import useMedia from 'syf-js-utilities/hooks/useMedia';
const Viewport = {
    Desktop: ({ children, query }) => useMedia([query !== null && query !== void 0 ? query : mediaQueries.greaterThanMedium], [true], false)
        ? children
        : null,
    Mobile: ({ children, query }) => useMedia([query !== null && query !== void 0 ? query : mediaQueries.lessThanMedium], [true], false)
        ? children
        : null
};
export default Viewport;
//# sourceMappingURL=viewport.js.map